import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { ApplePayExpressCheckoutButtonContainer } from '@grandvisionhq/payments';
import { useCartStorage } from '../../../../hooks/use-cart-storage.js';
import { FixCartButtonContainer } from '../../containers/FixCartButtonContainer.js';

const Navigation = ({ labels , unavailableLineItems  })=>{
    const [{ cartId  }] = useCartStorage();
    return /*#__PURE__*/ React.createElement("div", {
        className: "cart-navigation"
    }, /*#__PURE__*/ React.createElement(Button, {
        className: "cart-navigation__button",
        "data-t": "cart-go-back",
        caption: labels.goBack,
        variant: "outline",
        href: "/"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-button-container"
    }, !(unavailableLineItems === null || unavailableLineItems === void 0 ? void 0 : unavailableLineItems.length) && cartId && /*#__PURE__*/ React.createElement(ApplePayExpressCheckoutButtonContainer, {
        cartId: cartId
    }), /*#__PURE__*/ React.createElement(FixCartButtonContainer, {
        labels: labels,
        unavailableLineItems: unavailableLineItems
    })));
};

export { Navigation };
//# sourceMappingURL=Navigation.js.map
